import { IRepository, IRepositoryCategory } from '@/types';
import { flattenCategoriesUp } from '@/lib/categoryHelpers';

export const getFlattenedCategories = (repository: IRepository): IRepositoryCategory[] => {
  if (!repository.categories) {
    return [];
  }
  return flattenCategoriesUp(repository.categories as IRepositoryCategory[]);
};
